export enum MICRO_APP_PICKER {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=617027624
     */
    INPUT_VARIABLES = 'MICROAPP.INPUT_VARIABLES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=714861234
     */
    INPUT_VARIABLES_DESCRIPTION = 'MICROAPP.INPUT_VARIABLES_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=447140755
     */
    SELECT_MICRO_APPS = 'MICRO_APP_PICKER.SELECT_MICRO_APPS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=458875991
     */
    SELECT_MICRO_APP = 'MICRO_APP_PICKER.SELECT_MICRO_APP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=240919451
     */
    SETUP_MICROAPP = 'CONNECTORS.SETUP',
}
